var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_c('font-awesome-icon',{attrs:{"icon":"question-circle"}}),_vm._v("\n    "+_vm._s(_vm.$t('help.title'))+"\n  ")],1),_vm._v(" "),_c('div',{staticClass:"lead mt-4",domProps:{"innerHTML":_vm._s(_vm.$t('help.data'))}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9de4beb6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Help.vue
// module id = 1049
// module chunks = 0